<template>
  <div class="flex box-gap">
    <div class="calculator-box">
      <el-select
        class="mgb32 w-full"
        v-model="nodeName"
        filterable
      >
        <el-option
          v-for="item in nodelist"
          :disabled="isDisabled(item.progress)"
          :key="item.name"
          :label="item.name + ' ' + item.annual"
          :value="item.name"
        >
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right;">{{ item.annual }}</span>
        </el-option>
      </el-select>
      <div class="mgb40 w-full">
        <p class="calculator-item-title">{{ $t("calculator.stakeamount") }}</p>
        <div class="calculator-item-input">
          <el-input
            class="mgb12"
            v-model="stakeAmount"
            oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            placeholder="0"
          />
          <div class="calc-msg">
            {{ $t("calculator.maxstakeMsg") }}
            {{ $HelperTools.toFinancialVal(maxAmount) }} ONT
          </div>
          <div v-if="beCnode" class="calc-msg">
            {{ $t("calculator.nodeChangeMsg") }}
            <a :href="$t('calculator.url')" target="_blank">
              {{ $t("calculator.doc") }}
            </a>
          </div>
        </div>
      </div>
      <button class="calculator-btn" @click="calculator()">
        {{ $t("calculator.calc") }}
      </button>
    </div>
    <calc-result
      :totalRate="this.totalRate"
      :totalAmount="this.totalAmount"
      :feeRate="this.userinfo.user_gas_fee_incentive_rate"
      :feeAmount="this.userinfo.user_gas_fee_incentive"
      :releasedRate="this.userinfo.user_released_ong_incentive_rate"
      :releasedONG="this.userinfo.user_released_ong_incentive"
    />
  </div>
</template>

<script>
import CalcResult from "./CalcResult.vue";
export default {
  name: "calculatorUser",
  components: { CalcResult },
  props: {
    leastNum: {
      type: Number,
    },
    nodelist: {
      type: Array,
    },
    totalmaxAmount: {
      type: Number,
    },
  },
  data() {
    return {
      stakeAmount: 1,
      nodeName: "",
    };
  },
  computed: {
    userinfo() {
      return this.$store.getters.userinfo || 0;
    },
    totalRate() {
      const num = parseFloat(this.userinfo.user_foundation_bonus_incentive_rate) +
        parseFloat(this.userinfo.user_gas_fee_incentive_rate) +
        parseFloat(this.userinfo.user_released_ong_incentive_rate);
      if (isNaN(num)) return ''
      return num.toFixed(2) + "%"
    },
    totalAmount() {
      const num = parseFloat(this.userinfo.user_foundation_bonus_incentive) +
        parseFloat(this.userinfo.user_gas_fee_incentive) +
        parseFloat(this.userinfo.user_released_ong_incentive);
      if (isNaN(num)) return
      return num
    },
    beCnode() {
      let amount =
        parseInt(this.stakeAmount) + parseInt(this.nodeCurrentAmount);
      if (this.nodeCurrentAmount >= this.leastNum) {
        return false;
      } else {
        if (amount > this.leastNum) {
          return true;
        } else {
          return false;
        }
      }
    },
    selectedIndex() {
      return this.nodelist.findIndex(item => item.name === this.nodeName)
    },
    maxAmount() {
      const i = this.selectedIndex
      return this.nodelist[i].init_pos +
        this.nodelist[i].max_authorize -
        this.nodelist[i].current_stake
    },
    nodeCurrentAmount() {
      const i = this.selectedIndex
      return this.nodelist[i].current_stake
    },
    nodePublicKey() {
      const i = this.selectedIndex
      return this.nodelist[i].public_key
    }
  },
  mounted() {
    this.nodelist.sort(function(a, b) {
      var x = parseFloat(a.annual);
      var y = parseFloat(b.annual);
      if (x < y) {
        return 1;
      }
      if (x > y) {
        return -1;
      }
      return 0;
    });
    this.nodeName = this.nodelist[0].name;
  },
  methods: {
    isDisabled($progress) {
      let res;
      if ($progress === "100.00%") {
        res = true;
      } else {
        res = false;
      }
      return res;
    },
    calculator() {
      if (
        parseInt(this.stakeAmount) > this.totalmaxAmount ||
        parseInt(this.stakeAmount) > this.maxAmount
      ) {
        let amount = 0;
        if (this.totalmaxAmount > this.maxAmount) {
          amount = this.maxAmount;
        } else {
          amount = this.totalmaxAmount;
        }
        amount = this.$HelperTools.toFinancialVal(amount);
        this.$message({
          message: this.$t("calculator.maxstakeMsg") + amount + " ONT",
          type: "warning",
        });
        return;
      }
      let params = {
        public_key: this.nodePublicKey,
        stake_amount: this.stakeAmount,
      };
      this.$store.dispatch("getUserInfo", params).then();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
<style lang="scss">
/* 由于下拉框是附加到 body 下的，这里无法使用 v-deep 限制，只能使用全局样式覆盖 */
.el-scrollbar {
  margin-bottom: 18px;
}
.el-select-dropdown__wrap {
  @include mobile {
    max-height: 170px;
  }
}
</style>